import React from "react";
import "./AccessDenied.styles.scss";
import { Button } from "@mui/material";

interface IAccessDenied {
  title: string;
  redirectClick: () => void;
}

export const AccessDenied: React.FC<IAccessDenied> = ({ title, redirectClick }) => {
  return (
    <div className="access-denied page">
      <div className="access-denied__stub">
        <div className="access-denied__title">The content of this page is not available to you</div>
        <Button onClick={redirectClick} variant="contained">
          {title}
        </Button>
      </div>
    </div>
  );
};
